import * as React from "react";
import { Input } from "./Input";
import { extendFormGroupProps } from "./use-form-group";
import { ValidationErrors } from "./ValidationErrors";
export function FormInputContainer(props) {
    var type = props.type || "text";
    var renderLabelFirst = type !== "checkbox";
    if (type === "hidden") {
        return null;
    }
    return React.createElement("div", { className: props.containerClassName || 'form-group' },
        renderLabelFirst && props.labelText && React.createElement("label", null, props.labelText),
        type === "checkbox" ?
            React.createElement("label", null,
                props.children,
                " \u00A0",
                props.labelText || props.placeholder || "")
            :
                props.children,
        React.createElement(ValidationErrors, { errors: props.errors, name: props.name, className: props.validationErrorsClassName }));
}
export function FormInput(props) {
    props = extendFormGroupProps(props);
    var type = props.type || "text";
    var controlClassName = props.inputClassName || (type !== "checkbox" && type !== "radio" ? 'form-control' : undefined);
    return React.createElement(FormInputContainer, Object.assign({}, props),
        React.createElement(Input, Object.assign({}, props, { className: controlClassName, style: props.inputStyle, id: props.inputId })));
}
//# sourceMappingURL=FormInput.js.map